import { Card } from '../../../../../../components/card/card';
import { Checkbox } from '../../../../../../components/checkbox/checkbox';
import { Container } from '../../../../../../components/container/container';
import { Select } from '../../../../../../components/select/select';
import { LangInput } from '../../../../../../features/lang-input/lang-input';
import s from './qr-settings.module.css';
import { useQrSettings } from './use-qr-settings';

export const QrSettings = () => {
  const {
    qr,
    branches,
    handleChangeBranch,
    handleChangeDescription,
    handleChangeName,
    handleChangeIsDistance,
    t,
  } = useQrSettings();

  return (
    <Card className={s.feature} title={`1. ${t('Настройки')}`} withLang>
      <Container required label={t('Филиал')}>
        <Select
          options={branches}
          onSelect={handleChangeBranch}
          value={branches.find((item) => item.id === String(qr?.place_id))}
          name="branch"
          data-testid="qr-branch"
        />
      </Container>
      <Container required label={t('Название')}>
        <LangInput value={qr?.name} onChange={handleChangeName} name="name" data-testid="qr-name" />
      </Container>

      <Container label={t('Описание')}>
        <LangInput
          value={qr?.description}
          onChange={handleChangeDescription}
          data-testid="qr-description"
        />
      </Container>
      <Checkbox
        label={t('Дистанционный')}
        checked={qr?.is_distance}
        onClick={handleChangeIsDistance}
        data-testid="qr-is-distance"
      />
    </Card>
  );
};
